import React, { useEffect, useState } from 'react'
import AppButtons from '../../components/AppButtons/AppButtons'
//import SuccessImage from './assets/success.svg?svgr-webpack'
import Confetti from '../../components/Confetti'
import { FormattedMessage } from 'react-intl'
import { selectFirstName } from 'js/store/userSlice'
import { useSelector } from 'react-redux'

export default function Success() {
  const [confetti, setConfetti] = useState(true)
  const firstName = useSelector(selectFirstName)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setConfetti(false)
    }, 8000)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [])

  return (
    <>
      <div className="flex w-full flex-col gap-6 md:gap-10 lg:flex-row">
        {/*
        <div className="relative flex md:mb-16 lg:my-32 lg:w-1/2">
          <SuccessImage className="mx-auto my-auto ml-auto h-auto md:w-auto lg:mr-0" />
        </div>
        */}
        <div className="my-auto text-center lg:w-1/2 lg:px-32 xl:px-64">
          <h1 className="type-med-fat text-Brand">
            <FormattedMessage
              id="gympass_thanks_heading"
              defaultMessage="Thank you, {firstName}"
              values={{ firstName }}
            />
          </h1>
          <p className="mb-32 mt-20 leading-body lg:mb-48">
            <FormattedMessage
              id="gympass_all_done"
              defaultMessage="The setup is all done and your Lifesum Premium account is ready for you. Excited to get started? Download the app here:"
            />
          </p>
          <AppButtons
            appStoreUrl="https://app.adjust.com/uxsz4zg"
            googlePlayUrl="https://app.adjust.com/lnd3y7x"
          />
        </div>
      </div>
      {confetti && <Confetti />}
    </>
  )
}
